module.exports = __webpack_public_path__ + "img/19_26.c1163d05.png";